<template>
  <a-modal
    width="70%"
    title="修改设备类型"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="cancel"
    destroyOnClose>
    <div class="main">
      <div class="left">
        <h2>请选择要修改的设备类型</h2>
        <!-- <template v-for="(item, key, index) in record">
          <div :key="index" v-show="checkShow(key)" class="info">
            {{key}} : {{item}}
          </div>
        </template> -->
        <label class="text">设备类型:</label>
        <a-select class="sel" :defaultValue="record.model" @change="handleChange">
          <template v-for="(item) in models">
            <a-select-option :value="item.id" :key="item.id">{{item.name}}</a-select-option>
          </template>
        </a-select>
      </div>
      <div class="right">

      </div>
    </div>
  </a-modal>
</template>
<script>
import config from '../../config'
export default {
  props: {
    record: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      models: [],
      visable: true,
      deviceModelId: ''
    }
  },
  methods: {
    // 获取所有设备类型
    getAllDeviceTypes() {
      this.$http.get(config.api.device_types_url).then((response) => {
        // console.log(response.result)
        this.models = response.result.map((model) => {
          return {
            name: model.name,
            id: model.id
          }
        })
        // console.log(this.models)
      })
    },
    // ok
    handleOk () {
      if (this.deviceModelId) {
        this.$http.post(config.api.revise_device_type + this.deviceModelId, [this.record.id]).then((res) => {
          // console.log(res)
          let {code, result} = res
          if (code === 0) {
            // ....
            this.$message.success('修改成功！')
            this.visable = false
            this.$emit('reviseOk')
          } else {
            this.$message.error(res.desc)
          }
        })
      }
    },
    // cancel
    cancel () {
      this.visable = false
      this.$emit('quit')
    },
    checkShow (key) {
      let shows = ['iccid', 'sn', 'imei', 'imsi', 'model', 'orgName']
      console.log(shows.some(key) ? true : false)
      return shows.some(key) ? true : false
    },
    handleChange (value) {
      console.log(value)
      this.deviceModelId = value
    }
  },
  created() {
    this.getAllDeviceTypes()
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 10px;
}
.sel {
  width: 300px;
}
</style>